import Vue from 'vue';
import Vuex, { Store } from 'vuex';
import { landingPages } from './landing_pages/index';
import { DraftingTableState } from './types';
import { companySettings } from './company_settings/index';
import { mutations } from './mutations';
import { getters } from './getters';
import { jobLists } from './job_lists/index';
import { formTemplates } from './form_templates/index';
import { actions } from './actions';
import { forms } from './forms';
import { jobs } from './jobs';
import { jobWizard } from '@/store/core/jobs/wizard';
import { companies } from './companies';
import { profile } from './profile';
import { cities } from './cities';
import { candidates } from './candidates';
import { talentCard } from './talent_card';
import { jobPortal } from './portal_integrations';
import { companyModule } from './company';
import { v3 } from './v3';
import { userGroups } from './user_groups';
import { oldMol } from './old_mol';
import { mol } from './mol';
import { auth } from '@/store/core/auth';
import { userSetup } from '@/store/core/setup';
import { v4 } from './v4';
import { mobile } from '@/store/core/mobile';
import { formResponse } from '@/store/core/talent_card/form_response';
import { adAccounts } from '@/store/core/ad_accounts';
import { callLogs } from './call_logs';
import { units } from './units';
import { beta } from '@/store/core/beta';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
Vue.use(Vuex);
export default new Store({
    state: {
        authChecked: false,
        activeModule: null,
        route: null,
        features: null,
        draftingTableState: DraftingTableState.INITIAL,
        hideMainNav: false,
        mobileBreakpoint: 768,
        usingMobile: false,
        attributes: [],
        loadingAttributes: false,
    },
    getters: getters,
    actions: actions,
    mutations: mutations,
    modules: {
        landingPages: landingPages,
        companySettings: companySettings,
        jobLists: jobLists,
        formTemplates: formTemplates,
        forms: forms,
        jobs: jobs,
        companies: companies,
        profile: profile,
        cities: cities,
        candidates: candidates,
        talentCard: talentCard,
        jobPortal: jobPortal,
        companyModule: companyModule,
        v3: v3,
        userGroups: userGroups,
        oldMol: oldMol,
        mol: mol,
        auth: auth,
        userSetup: userSetup,
        jobWizard: jobWizard,
        v4: v4,
        mobile: mobile,
        formResponse: formResponse,
        adAccounts: adAccounts,
        callLogs: callLogs,
        units: units,
        beta: beta,
    },
});
